export default "__VITE_ASSET__CkTHMvbu__"